<template>
  <div class="bg-white rounded-lg shadow-sm divide-y divide-gray-200">
    <div class="p-4 md:p-8 flex max-md:flex-col gap-6">
      <div class="w-full md:w-1/4">
        <img
          v-if="imagePath(lesson)"
          :src="imagePath(lesson)"
          :alt="lesson.title"
          aria-hidden="true"
          class="object-contain w-[200px] mx-auto"
        >
      </div>

      <div class="flex flex-col gap-4 w-full md:w-3/4">
        <a
          :href="lessonUrl(lesson)"
          class="link link--blue hover:underline"
        >
          <h2 class="text-3xl flex gap-2.5 items-baseline">
            <SvgIcon
              aria-hidden="true"
              icon-name="signs-post"
              class="shrink-0"
              width="16"
              height="16"
            />
            {{ lesson.title }}
          </h2>
        </a>
        <ul class="bg-blue-dark-50 py-5 px-6 rounded-lg flex flex-col gap-4 text-sm text-gray-800">
          <li>
            <h3 class="flex gap-2 font-bold items-center">
              <SvgIcon
                aria-hidden="true"
                icon-name="book"
                class="shrink-0"
                width="16"
                height="16"
              />
              <span>Lesson</span>
            </h3>
            <p>
              {{ lesson.challengeCount }} challenges {{ lesson.hasAudio ? 'and audio content' : '' }}
            </p>
          </li>
        </ul>
        <div class="prose">
          <div v-html="lesson.summary" />

          <a
            v-if="!isDetails"
            :href="lessonUrl(lesson)"
          >
            <span>Read more...</span>
            <span class="sr-only">about {{ lesson.title }}</span>
          </a>
        </div>
        <div class="flex flex-wrap gap-2">
          <a
            :href="appUrl('signin')"
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn--sm btn--primary"
          >
            Log In to Assign
          </a>
          <a
            :href="appUrl('signup')"
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn--sm btn--secondary"
          >
            Sign Up Today
          </a>
        </div>
      </div>
    </div>

    <details>
      <summary class="flex gap-2 px-4 pt-4 md:px-8 pb-5 items-center text-blue-600 hover:text-blue-800 cursor-pointer">
        <h3>Details</h3>
        <SvgIcon
          aria-hidden="true"
          icon-name="angle"
          class="shrink-0"
          width="16"
          height="16"
        />
      </summary>
      <div class="px-4 pb-6 md:px-8 md:pb-8 text-gray-800">
        <DetailList :lesson="lesson" />
      </div>
    </details>
  </div>
</template>

<script lang="ts">
export default { name: 'LessonCard' }
</script>

<script setup lang="ts">
import { appUrl, lessonUrl } from '~/lib/url'

import { LessonRecord } from '~/types/records/LessonRecord'

import DetailList from './LessonDetailList.vue'

withDefaults(
  defineProps<{
    lesson: LessonRecord,
    isDetails?: boolean
  }>(), {
    isDetails: false,
  },
)

const imagePath = (lesson: LessonRecord) => lesson.coverImagePreview ?? lesson.coverImage

</script>
